<template>
  <a-modal centered
           :visible="visible"
           title="添加商标释义"
           @ok="on_submit"
           @cancel="cancel"
           :confirmLoading="submitting"
           :width="420">
    <a-form-model :model="form" ref="paraphrase_create" :rules="rules" layout="vertical">
      <a-form-model-item label="释义">
        <a-textarea :rows="13" v-model="form.paraphrase" allowClear/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
let init_form = {
  paraphrase: null,
};
export default {
  props: {
    visible: {
      default: false
    },
    record: null,
    callback: null
  },
  data() {
    return {
      submitting: false,
      loading_member: false,
      data_member: [],
      form: {},
      rules: {
        paraphrase: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "释义必填"
          }
        ],
      }
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
  },
  watch: {
    visible(v) {
      if (v && this.record) {
        Object.keys(this.form).map((v) => {
          if (Object.prototype.hasOwnProperty.call(this.record, v)) {
            this.form[v] = this.record[v];
          }
        });
      }
    }
  },
  methods: {
    cancel() {
      this.form = JSON.parse(JSON.stringify(init_form));
      this.$emit("close");
    },
    on_submit() {
      this.$refs["paraphrase_create"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$http
            .post("/trademark/paraphrase/" + this.record.applyNo, this.form)
            .then((res) => {

              if (res.success) {
                this.cancel();
                if (this.callback) {
                  this.callback();
                }
              } else {
                this.$error({ title: "失败", centered: true, content: res.message });
              }

              /*if (res.success) {
                this.$message.success(res.message);
                this.load();
                this.cancel();
                if (this.callback) {
                  this.callback(JSON.parse(JSON.stringify(this.form)));
                }
                this.visible = false;
                this.form = JSON.parse(JSON.stringify(init_form));
              } else {
                this.$error({ title: "失败", centered: true, content: res.message });
              }*/
            })
            .catch(() => {
            })
            .then(() => {
              this.submitting = false;
            });
          this.$emit("close");
        } else {
          this.$message.error("请检查并填写完需要录入的内容");
          return false;
        }
      });
    },
    after_close() {
      this.$refs["paraphrase_create"].resetFields();
      this.form = JSON.parse(JSON.stringify(init_form));
    }
  }
};
</script>
